import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  editItem: {
    id: 'sku-edit-item-form.edit-item',
    defaultMessage: 'Edit {itemName}',
  },
  viewItem: {
    id: 'sku-edit-item-form.view-item',
    defaultMessage: 'View {itemName}',
  },
  closeButton: {
    id: 'sku-edit-item-form.button.close',
    defaultMessage: 'Close',
  },
  itemNameLabel: {
    id: 'sku-edit-item-form.label.item-name',
    defaultMessage: 'Item name',
  },
  itemDescriptionLabel: {
    id: 'sku-edit-item-form.label.item-description',
    defaultMessage: 'Item description',
  },
  itemDescriptionPlaceholder: {
    id: 'sku-edit-item-form.placeholder.item-description',
    defaultMessage: 'E.g. "Seasonal berry smoothie. Contains soy and tree nuts."',
  },
  categoryLabel: {
    id: 'sku-edit-item-form.label.category',
    defaultMessage: 'Select categories',
  },
  categoryLabelReadOnly: {
    id: 'sku-edit-item-form.label.category-read-only',
    defaultMessage: 'Categories',
  },
  selectCategory: {
    id: 'sku-edit-item-form.select-category',
    defaultMessage: 'Select categories',
  },
  addCategoryLabel: {
    id: 'sku-edit-item-form.add-category-label',
    defaultMessage: 'Add category',
  },
  menuPriceLabel: {
    id: 'sku-edit-item-form.label.update-menu-price',
    defaultMessage: 'Update menu price',
  },
  taxExcludedMenuPriceDescription: {
    id: 'sku-edit-item-form.description.menu-price-tax-excluded',
    defaultMessage: "The price on your menu, not including tax. We'll use this to calculate your payout.",
  },
  taxIncludedMenuPriceDescription: {
    id: 'sku-edit-item-form.description.menu-price-tax-included',
    defaultMessage: "The price on your menu, including tax. We'll use this to calculate your payout.",
  },
  linkToMenuLabel: {
    id: 'sku-edit-item-form.label.link-to-menu',
    defaultMessage: 'Link to menu',
  },
  linkToMenuPlaceholder: {
    id: 'sku-edit-item-form.placeholder.link-to-menu',
    defaultMessage: 'https://www.example.com/menu',
  },
  linkToMenuDescription: {
    id: 'sku-edit-item-form.description.link-to-menu',
    defaultMessage: 'Required for price verification.',
  },
  submitButton: {
    id: 'sku-edit-item-form.button.submit',
    defaultMessage: 'Submit for review',
  },
  submittingButton: {
    id: 'sku-edit-item-form.button.submitting',
    defaultMessage: 'Submitting...',
  },
  invalidUrl: {
    id: 'sku-edit-item-form.errors.invalid-url',
    defaultMessage: 'Please enter a valid link.',
  },
  categoryRequired: {
    id: 'sku-edit-item-form.errors.category-required',
    defaultMessage: 'Please select at least one category.',
  },
  priceMustBePositive: {
    id: 'sku-edit-item-form.errors.price-must-be-positive',
    defaultMessage: 'Menu price must be greater than $0.',
  },
  errorEditItem: {
    id: 'sku-edit-item-form.errors.edit-item',
    defaultMessage: '<strong>We were unable to edit your item</strong>',
  },
  formSubmitError: {
    id: 'sku-edit-item-form.errors.form-submit-error',
    defaultMessage:
      'Oops! We were unable to submit your item. Please make sure you filled out all required fields correctly.',
  },
  successEditItem: {
    id: 'sku-edit-item-form.success.edit-item',
    defaultMessage: '<strong>{itemName}</strong> was successfully updated and is now in review.',
  },
  pricingFieldsHelperText: {
    id: 'sku-edit-item-form.helper.pricing-fields',
    defaultMessage:
      'Your previously submitted pricing is stored with our team. Leave these fields empty to keep it unchanged, or fill both to submit updated pricing for verification.',
  },
  priceVerificationInfo: {
    id: 'sku-edit-item-form.info.price-verification',
    defaultMessage:
      'If your menu price changes, our team will need to verify the new price before it becomes available to order.',
  },
});
